const STORAGE_KEY = 'griot-promo-dismissal-v2';
const DISMISS_MS = 24 * 60 * 60 * 1000;
const DEFAULT_VERSION = 'griot-26-pricing-v1';

function readDismissal(storage) {
  try {
    const value = JSON.parse(storage.getItem(STORAGE_KEY));

    if (!value || typeof value.version !== 'string') return null;
    if (!Number.isFinite(value.hiddenUntil)) return null;

    return value;
  } catch (error) {
    return null;
  }
}

if (!customElements.get('griot-promo-banner')) {
  class GriotPromoBanner extends HTMLElement {
    constructor() {
      super();
      this.handleDismiss = this.handleDismiss.bind(this);
    }

    connectedCallback() {
      this.dismissalVersion = this.dataset.dismissalVersion || DEFAULT_VERSION;
      const dismissal = readDismissal(window.localStorage);

      if (
        !dismissal ||
        dismissal.version !== this.dismissalVersion ||
        dismissal.hiddenUntil <= Date.now()
      ) {
        this.hidden = false;
      }

      if (!this.dismissButton) {
        this.dismissButton = this.querySelector('[data-griot-promo-dismiss]');
        this.dismissButton?.addEventListener('click', this.handleDismiss);
      }
    }

    handleDismiss(event) {
      event.preventDefault();
      this.hidden = true;

      try {
        window.localStorage.setItem(
          STORAGE_KEY,
          JSON.stringify({
            version: this.dismissalVersion,
            hiddenUntil: Date.now() + DISMISS_MS,
          }),
        );
      } catch (error) {
        // Storage can be unavailable; the banner remains hidden for this page.
      }
    }
  }

  customElements.define('griot-promo-banner', GriotPromoBanner);
}
